import React, { useState, useEffect } from "react";
import { Table, Col, Button, Form, Row, Image, Modal } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";
import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import BasicPagination from "../../../Pagination/Pagination";
import {
  getAllCateogryForIcons,
  getSubCateogryWithCategoryId,
  addNewSubCategoryFromCategory,
  editSubCategoryFromCategory,
  deleteSubCategoryFromCategory,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { useFormik } from "formik";
import * as yup from "yup";
import IconUserModal from "./IconUserModal";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import Alert from "react-s-alert";
import { errorAlert, successAlert } from "../../../../function/alert";

const validationSchema = yup.object({
  icon_code: yup
    .string()
    .required("Icon code is required")
    .min(1, "Icon code is required"),

  title: yup
    .string()
    .required("Sub category name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  selected_category: yup.string().required("Please select Category"),
  code: yup.string(),
  icon: yup.string(),
  photo: yup.string()
  // description: yup
  //   .string()
  //   .required("Description is required")
  //   .min(1, "Minimum 1 Character")
  //   .max(64, "Maximum 512 Character"),
});
const SuperAdminMainListOfIcon = (props) => {
  const formik = useFormik({
    initialValues: {
      icon_code: "",
      title: "",
      selected_category: "",
      code: "",
      photo: "",
      icon: "",
      description: "",
    },
    validationSchema,

    onSubmit: (values) => {
      const onSuccessAddSubCategory = () => {
        // if (selected_category) {
        // }
        if (values.selected_category === selectedCategory) {
          var dataToAdd = {};
          dataToAdd.icon_code = values.icon_code;
          dataToAdd.name = values.title;
          dataToAdd.description = values.description;
          dataToAdd.code = values.code;
          dataToAdd.photo = values.photo
          dataToAdd.icon = values.icon;
          dataToAdd.id = values.selected_category;

          getSubCategory([...subCategory, dataToAdd]);
        }
        handleCloseAdd();
        formik.resetForm();
        setLoading(false);
      };

      const onErrorAddSubCateogry = () => { };
      //edit

      const onSuccessEditSubCategory = () => {
        var updateSubCategory = subCategory.map((item) => {
          if (item.id === selectedSubCategory) {
            return {
              ...item,
              icon_code: values.icon_code,
              name: values.title,
              code: values.code,
              photo: values.photo,
              icon: values.icon,
              status: values.status,
              description: values.description,
            };
          } else {
            return item;
          }
        });
        getSubCategory(updateSubCategory);
        handleCloseEdit();

        formik.resetForm();
        setLoading(false);
      };

      const onErrorEditSubCateogry = () => {
        formik.resetForm();
        setLoading(false);
      };

      const token = props.auth.user.accessToken;
      values.status = "APPROVED";
      setLoading(true);
      if (editStatus) {
        delete values["selected_category"];
        props.editSubCategoryFromCategory(
          selectedSubCategory,
          values,
          token,
          onSuccessEditSubCategory,
          onErrorEditSubCateogry
        );
      } else {
        props.addNewSubCategoryFromCategory(
          values,
          token,
          onSuccessAddSubCategory,
          onErrorAddSubCateogry
        );
      }
    },
  });
  //state
  const [active, setActive] = useState(0);
  const [editStatus, setEditStatus] = useState(false);
  const [showDeleteIcon, setShowDeleteIcon] = useState(false);
  const [showEditIcon, setShowEditIcon] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [file, setFile] = useState(null);
  const [photo, setPhoto] = useState(null);

  const [state, setState] = useState({
    category: "",
  });

  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const [editData, setEditData] = useState({
    name: "",
    id: "",
    icon: "",
    code: "",
    desc: "",
    photo: "",
    icon_code: "",
  });

  const handleBatchChange = (pageNo) => {
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const handleChangeCategoryAdd = (event) => {
    setState({ category: event.target.value });
    formik.setFieldValue("selected_category", event.target.value);
  };
  const handleShowIconList = (e, categoryId) => {
    setActive(e);
    setStart(0);
    setEnd(10);
    setPage(1);
    onClickGetSubCategory(categoryId);
    setSelectedCategory(categoryId);
    setLoading(true);
  };
  const handleCloseDeleteIcon = () => setShowDeleteIcon(false);
  const handleShowDeleteIcon = (id) => {
    setSubCategoryId(id);
    setShowDeleteIcon(true);
  };
  // for delete
  const [subCategoryId, setSubCategoryId] = useState();

  const onSuccessDeleteSubCategory = () => {
    setShowDeleteIcon(false);
    setLoading(false);

    const removeDeletedSubcategory = subCategory.filter((item) => {
      return item.id !== subCategoryId;
    });
    setSubCategoryId("");
    getSubCategory(removeDeletedSubcategory);
  };
  const onErrorDeleteSubCateogry = () => {
    setShowDeleteIcon(false);
    setLoading(false);
  };

  const onClickDeleteSubCategory = () => {
    const token = props.auth.user.accessToken;
    props.deleteSubCategoryFromCategory(
      subCategoryId,
      token,
      onSuccessDeleteSubCategory,
      onErrorDeleteSubCateogry
    );
  };

  const handleCloseEdit = () => setShowEdit(false);
  const handleCloseEditIcon = () => setShowEditIcon(false);

  const handleShowEditIcon = (name, id, icon, desc, code, icon_code, photo) => {
    console.log('name, id, icon, code, icon_code, photo,', name, id, icon, code, icon_code, photo, desc)
    setShowEditIcon(true);
    setEditData({
      name: name,
      id: id,
      icon: icon,
      desc: desc,
      code: code,
      icon_code: icon_code,
      photo: photo
    });
  };

  const onStatuSuccess = (data, status) => {
    let updateSubCategory = subCategory.map((item) => {
      if (item.id === data.id) {
        return {
          ...item,
          status: status,
        };
      } else {
        return item;
      }
    });
    getSubCategory(updateSubCategory);
  };

  const handleStatus = (data, status) => {
    let obj = { status: status };
    const token = props.auth.user.accessToken;
    props.editSubCategoryFromCategory(
      data.id,
      obj,
      token,
      () => onStatuSuccess(data, status),
      () => {
        errorAlert("Error updating Status");
      }
    );
  };

  const handleShowEdit = () => {
    console.log('editData', editData)
    handleCloseEditIcon();
    formik.setFieldValue("icon_code", editData?.icon_code || "");

    formik.setFieldValue("title", editData?.name);
    setFile(editData?.icon || null);
    setPhoto(editData?.photo || null);

    setSelectedSubCategory(editData?.id);
    formik.setFieldValue("selected_category", editData?.id);
    formik.setFieldValue("icon", editData?.icon || "");
    formik.setFieldValue("code", editData?.code || '');
    formik.setFieldValue("photo", editData?.photo || '');
    formik.setFieldValue("description", editData?.desc);
    setEditStatus(true);
    setShowEdit(true);
  };
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => {
    setEditStatus(false);
    formik.setFieldValue("title", "");
    setFile(null);
    setPhoto(null);
    setState({ category: "" });
    formik.setFieldValue("selected_category", "");
    formik.setFieldValue("icon", "");
    formik.setFieldValue("description", "");
    formik.setFieldValue("code", "");
    formik.setFieldValue("icon_code", "");
    setShowAdd(true);
  };
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const uploadImage = (e) => {
    const data = new FormData();
    data.append("files", e.target.files[0]);
    let name = e?.target?.name;
    //setFile(URL.createObjectURL(e.target.files[0]));

    axios
      .post(
        `${serverApi}/upload-assets?uploadSide=superadminCategoryicon&category=true`,
        data,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        if (name === 'icon') {
          setFile(res.data[0]);
          formik.setFieldValue("icon", res.data[0]);
        } else if (name === 'photo') {
          setPhoto(res.data[0]);
          formik.setFieldValue("photo", res.data[0]);
        }
      })
      .catch((err) => {
        Alert.error(`<h4>Error while uploading the image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      });
  };

  const removeIconAddCategory = () => {
    setFile(null);
    formik.setFieldValue("icon", "");
  };

  const removePhoto = () => {
    setPhoto(null);
    formik.setFieldValue("photo", "");
  };

  const [category, setCategory] = useState([]);
  const [subCategory, getSubCategory] = useState([]);

  const onClickGetSubCategory = (categoryId) => {
    props.getSubCateogryWithCategoryId(onSuccessGetSubCategory, categoryId);
  };

  const onSuccessGetSubCategory = (data) => {
    var subC = [];

    for (var i = 0; i < data.length; i++) {
      subC.push({
        icon_code: data[i]?.icon_code,
        name: data[i]?.title,
        id: data[i]?._id,
        status: data[i]?.status,
        code: data[i]?.code,
        photo: data[i]?.photo,
        icon: data[i]?.icon,
        description: data[i]?.description,
        hexColor: data[i]?.hexColor,
      });
    }
    getSubCategory(subC);
    setLoading(false);
  };

  const onSuccessGetFavChain = (data) => {
    var cateogryIcons = [];

    for (var i = 0; i < data.length; i++) {
      cateogryIcons.push({ name: data[i].title, id: data[i]._id, type: data?.[i]?.type || "", code: data?.[i]?.code || "" });
    }
    if (cateogryIcons.length > 0) {
      onClickGetSubCategory(cateogryIcons[0].id);
    }

    setCategory(cateogryIcons);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    props.getAllCateogryForIcons(onSuccessGetFavChain);
  }, []);

  const onChangeSearch = (e) => {
    setSearch(e.target.value);
    // getSubCategory([]);
  };
  let searchCat = new RegExp(search, "i");
  const filteredCategories = category.filter((catName) => {
    if (searchCat.test(catName.name) || searchCat.test(catName?.code)) {
      return catName;
    } else {
      return false;
    }
    // return catName.name.toLowerCase().includes(search);
  });

  const [searchSubCategory, setSearchSubCategory] = useState("");
  const onChangeSearchSubCategory = (e) => {
    setSearchSubCategory(e.target.value);
  };
  let searchData = new RegExp(searchSubCategory, "i");
  const filteredSubCategory = subCategory.filter((catName) => {
    if (searchData.test(catName.name)) {
      return catName;
    } else if (searchData.test(catName.icon_code)) {
      return catName;
    } else {
      return false;
    }
    // return catName.name.toLowerCase().includes(search);
  });
  //used for focus
  const [count, setCount] = useState(1);
  const onClickAddIcon = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.icon_code) {
      let iconElement = document.getElementById("iconCode");
      iconElement.focus();
    } else if (formik.errors && formik.errors.selected_category) {
      let selectedCatElement = document.getElementById("selected_category");
      selectedCatElement.focus();
    } else if (formik.errors && formik.errors.title) {
      let titleElement = document.getElementById("title");
      titleElement.focus();
    } else if (formik.errors && formik.errors.icon) {
      let iconCatElement = document.getElementById("icon");
      iconCatElement.focus();
    }
    // } else if (formik.errors && formik.errors.description) {
    //   let descriptionElement = document.getElementById("description");
    //   descriptionElement.focus();
    // }
  }, [count]);
  return (
    <>
      {!loading ? <></> : <AmealioLoader />}
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <Col>
                <Col
                  md={12}
                  className="d-flex justify-content-between align-items-center pt-4 pb-3"
                >
                  <div className="f24_700_HelveticaNeue">
                    Categories and Icons
                  </div>
                  <Button
                    variant="danger"
                    className="btn2 btn-lg"
                    onClick={handleShowAdd}
                  >
                    + Add Icon
                  </Button>
                </Col>
                <Col md={4}>
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    className="amSearch"
                    value={search}
                    onChange={(e) => onChangeSearch(e)}
                  />
                </Col>
              </Col>
              <div className="container-fluid">
                <Row>
                  <Col lg={4} className="p-lg-0">
                    <div className="bg-white enP075rem f16-500">Categories</div>
                    <Scrollbars style={{ width: "100%", height: 500 }}>
                      <div className="enCategoryList">
                        {filteredCategories.map((item, index) => (
                          <button
                            key={index}
                            type="button"
                            className={`f14-400 ${active === index ? "active" : ""
                              }`}
                            onClick={() => handleShowIconList(index, item.id)}
                          >
                            {item.name} {`${item?.type === 'EXPERIENCE' ? `- ${item?.code?.charAt(0).toUpperCase() + item?.code?.slice(1).toLowerCase()}` : ""}`}
                          </button>
                        ))}
                        {filteredCategories.length === 0 ? (
                          <> No record found </>
                        ) : (
                          <> </>
                        )}
                      </div>
                    </Scrollbars>
                  </Col>
                  <Col lg={8}>
                    <div className="d-flex align-items-center justify-content-end w-100">
                      <Col md={4}>
                        <Form.Control
                          type="search"
                          placeholder="Search Subcategory"
                          className="amSearch"
                          value={searchSubCategory}
                          onChange={(e) => onChangeSearchSubCategory(e)}
                        />
                      </Col>
                    </div>
                    <div className="user-table-reusable-superadmin table-responsive">
                      <Table className="enAuditLogTBL HideShowTable">
                        <thead>
                          <tr className="super_admin_all_users_table_head rounded-0">
                            <th className="f12-700" style={{ width: "10%" }}>
                              ID
                            </th>
                            {!filteredSubCategory[0]?.hexColor && (
                              <th className="f12-700" style={{ width: "20%" }}>
                                Icon Code
                              </th>
                            )}
                            <th className="f12-700" style={{ width: "20%" }}>
                              Icon
                            </th>
                            <th className="f12-700" style={{ width: "35%" }}>
                              Short description
                            </th>
                            {filteredSubCategory[0]?.hexColor && (
                              <th className="f12-700" style={{ width: "20%" }}>
                                Hex Code
                              </th>
                            )}
                            <th className="f12-700" style={{ width: "10%" }}>
                              Status
                            </th>
                            <th className="f12-700" style={{ width: "15%" }}>
                              Actions
                            </th>
                          </tr>
                        </thead>

                        {filteredSubCategory &&
                          filteredSubCategory
                            .slice(start, end)
                            .map((user, index) => (
                              <IconUserModal
                                key={index}
                                index={index}
                                icon_code={user.icon_code}
                                subCategory={
                                  filteredSubCategory && filteredSubCategory
                                }
                                hexColor={user?.hexColor}
                                id={user.id}
                                name={user.name}
                                icon={user.icon}
                                status={user.status}
                                photo={user.photo}
                                code={user?.code}
                                description={user.description}
                                handleStatus={handleStatus}
                                handleShowEdit={handleShowEditIcon}
                                handleShowDeleteIcon={() =>
                                  handleShowDeleteIcon(user.id)
                                }
                              />
                            ))}
                      </Table>
                    </div>

                    {filteredSubCategory && filteredSubCategory.length !== 0 ? (
                      <BasicPagination
                        totalRecords={
                          filteredSubCategory && filteredSubCategory.length
                        }
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal show={showDeleteIcon} onHide={handleCloseDeleteIcon} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to Delete the Icon ?
            <br />
            <div className="f10-400 pt-2" style={{ color: "#EE3A23" }}>
              Before continuing to Yes, make sure this Category is not been used
              or replace it with other category where ever it is Used.
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseDeleteIcon}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              //onClick={handleCloseDeleteIcon}
              onClick={onClickDeleteSubCategory}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showEditIcon} onHide={handleCloseEditIcon} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to Edit the Icon ?
            <div className="f10-400 pt-2" style={{ color: "#EE3A23" }}>
              Before continuing to Yes, make sure that the change will be
              reflecting in the Merchant side who ever subscribed this category.
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseEditIcon}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              //onClick={handleCloseDeleteIcon}
              onClick={handleShowEdit}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showEdit} onHide={handleCloseEdit} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title className="f20-500">
              Edit Category and Icon
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={formik.handleSubmit}>
              <Form.Group>
                <TextField
                  type="text"
                  id="iconCode"
                  variant="outlined"
                  label="Icon Code"
                  className={`w-100 ${formik.errors.icon_code && formik.touched.icon_code
                    ? "enError"
                    : ""
                    }`}
                  name="icon_code"
                  inputProps={{ maxLength: 10 }}
                  onChange={formik.handleChange}
                  value={formik.values.icon_code}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    formik.errors.icon_code && formik.touched.icon_code
                  }
                />
                {formik.errors.icon_code && formik.touched.icon_code ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.icon_code}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <FormControl variant="outlined" className="w-100">
                  <InputLabel htmlFor="outlined-Category">
                    Select Category
                  </InputLabel>

                  <Select
                    disabled
                    value={selectedCategory}
                    onChange={handleChangeCategoryAdd}
                    label="Select Category"
                    IconComponent={KeyboardArrowDownIcon}
                    inputProps={{
                      name: "category",
                      id: "outlined-Category",
                    }}
                  >
                    {category.map((item, index) => (
                      <option label={item.name} value={item.id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Form.Group>
              <Form.Group>
                <TextField
                  id="title"
                  variant="outlined"
                  label="Name"
                  className="w-100"
                  name="title"
                  onChange={formik.handleChange}
                  value={formik.values.title}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.title && formik.touched.title}
                />
                {formik.errors.title && formik.touched.title ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.title}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <TextField
                  id="code"
                  variant="outlined"
                  label="Code"
                  className="w-100"
                  name="code"
                  onChange={formik.handleChange}
                  value={formik.values.code}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.code && formik.touched.code}
                />
                {formik.errors.code && formik.touched.code ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.code}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <Form.Label className="f12-500">Normal State Icon</Form.Label>
                <div className="d-flex flex-wrap">
                  <div className="enUploadBox">
                    <Image
                      src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                      alt="uploadImg"
                      title="uploadImg"
                      fluid
                    />
                    <input
                      type="file"
                      name="icon"
                      accept="image/jpeg,image/jpg,image/png"
                      onChange={(e) => uploadImage(e)}
                    />
                  </div>
                  {file && (
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => removeIconAddCategory()}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/en_close.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                      </button>
                      <Image
                        src={file}
                        alt="icon"
                        title="icon"
                        className=""
                        fluid
                      />
                    </div>
                  )}
                </div>
                <div className="f10-400 opacity5">Upload SVG or PNG Icons</div>
                {formik.errors.icon && formik.touched.icon ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.icon}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <Form.Label className="f12-500">Photo</Form.Label>
                <div className="d-flex flex-wrap">
                  <div className="enUploadBox">
                    <Image
                      src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                      alt="uploadImg"
                      title="uploadImg"
                      fluid
                    />
                    <input
                      type="file"
                      name="photo"
                      accept="image/jpeg,image/jpg,image/png"
                      onChange={(e) => uploadImage(e)}
                    />
                  </div>
                  {photo && (
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => removePhoto()}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/en_close.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                      </button>
                      <Image
                        src={photo}
                        alt="photo"
                        title="photo"
                        className=""
                        fluid
                      />
                    </div>
                  )}
                </div>
                <div className="f10-400 opacity5">Upload Photo for Category</div>
                {formik.errors.photo && formik.touched.photo ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.photo}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <TextField
                  variant="outlined"
                  className="w-100"
                  multiline
                  rows={4}
                  label="Description"
                  name="description"
                  onChange={formik.handleChange}
                  value={formik.values.description}
                  onBlur={formik.handleBlur}
                // isInvalid={
                //   formik.errors.description && formik.touched.description
                // }
                />
                {/* {formik.errors.description && formik.touched.description ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.description}
                  </div>
                ) : null}{" "} */}
              </Form.Group>
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-4"
                  onClick={handleCloseEdit}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5"
                  type="submit"
                //onClick={handleCloseEdit}
                >
                  Save
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
        <Modal show={showAdd} onHide={handleCloseAdd} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title className="f20-500">Add Category and Icon</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <TextField
                  type="text"
                  id="iconCode"
                  variant="outlined"
                  label="Icon Code"
                  className="w-100"
                  name="icon_code"
                  inputProps={{ maxLength: 10 }}
                  onChange={formik.handleChange}
                  value={formik.values.icon_code}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    formik.errors.icon_code && formik.touched.icon_code
                  }
                />
                {formik.errors.icon_code && formik.touched.icon_code ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.icon_code}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <FormControl variant="outlined" className="w-100">
                  <InputLabel htmlFor="outlined-Category">
                    Select Category
                  </InputLabel>
                  <Select
                    id="selected_category"
                    value={state.category}
                    onChange={handleChangeCategoryAdd}
                    label="Select Category"
                    inputProps={{
                      name: "category",
                      id: "outlined-Category",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {category.map((item, index) => (
                      <option label={item.name} value={item.id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                  {formik.errors.selected_category &&
                    formik.touched.selected_category ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.selected_category}
                    </div>
                  ) : null}
                </FormControl>
              </Form.Group>
              <Form.Group>
                <TextField
                  id="title"
                  variant="outlined"
                  label="Name"
                  className="w-100"
                  name="title"
                  onChange={formik.handleChange}
                  value={formik.values.title}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.title && formik.touched.title}
                />
                {formik.errors.title && formik.touched.title ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.title}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <TextField
                  id="code"
                  variant="outlined"
                  label="Code"
                  className="w-100"
                  name="code"
                  onChange={formik.handleChange}
                  value={formik.values.code}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.code && formik.touched.code}
                />
                {formik.errors.code && formik.touched.code ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.code}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <Form.Label className="f12-500">Normal State Icon</Form.Label>
                <div className="d-flex flex-wrap">
                  <div className="enUploadBox">
                    <Image
                      src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                      alt="uploadImg"
                      title="uploadImg"
                      fluid
                    />
                    <input
                      id="icon"
                      type="file"
                      name="icon"
                      //accept=".png, .svg"
                      // accept="image/jpeg,image/jpg,image/png"
                      onChange={(e) => uploadImage(e)}
                    />
                  </div>
                  {file && (
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => removeIconAddCategory()}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/en_close.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                      </button>
                      <Image
                        src={formik.values.icon}
                        alt="icon"
                        title="icon"
                        className=""
                        fluid
                      />
                    </div>
                  )}
                </div>
                <div className="f10-400 opacity5">Upload SVG or PNG Icons</div>
                {formik.errors.icon && formik.touched.icon ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.icon}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <Form.Label className="f12-500">Photo</Form.Label>
                <div className="d-flex flex-wrap">
                  <div className="enUploadBox">
                    <Image
                      src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                      alt="uploadImg"
                      title="uploadImg"
                      fluid
                    />
                    <input
                      id="icon"
                      type="file"
                      name="photo"
                      //accept=".png, .svg"
                      // accept="image/jpeg,image/jpg,image/png"
                      onChange={(e) => uploadImage(e)}
                    />
                  </div>
                  {photo && (
                    <div className="enIconUploaded">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => removePhoto()()}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/en_close.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                      </button>
                      <Image
                        src={formik.values.photo}
                        alt="photo"
                        title="photo"
                        className=""
                        fluid
                      />
                    </div>
                  )}
                </div>
                <div className="f10-400 opacity5">Upload Photo for Category</div>
                {formik.errors.photo && formik.touched.photo ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.photo}
                  </div>
                ) : null}{" "}
              </Form.Group>
              <Form.Group>
                <TextField
                  id="description"
                  variant="outlined"
                  className="w-100"
                  multiline
                  rows={4}
                  label="Description"
                  name="description"
                  onChange={formik.handleChange}
                  value={formik.values.description}
                  onBlur={formik.handleBlur}
                // isInvalid={
                //   formik.errors.description && formik.touched.description
                // }
                />
                {/* {formik.errors.description && formik.touched.description ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.description}
                  </div>
                ) : null}{" "} */}
              </Form.Group>
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-4"
                  onClick={handleCloseAdd}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5"
                  //onClick={handleCloseAdd}

                  onClick={() => onClickAddIcon()}
                >
                  Save
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </>
  );
};

SuperAdminMainListOfIcon.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllCateogryForIcons: PropTypes.func.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
  addNewSubCategoryFromCategory: PropTypes.func.isRequired,
  editSubCategoryFromCategory: PropTypes.func.isRequired,
  deleteSubCategoryFromCategory: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getAllCateogryForIcons,
  getSubCateogryWithCategoryId,
  addNewSubCategoryFromCategory,
  editSubCategoryFromCategory,
  deleteSubCategoryFromCategory,
})(SuperAdminMainListOfIcon);
//
